import styled from 'styled-components'
import theme from '../../global/theme'

export const PerfilContainer = styled.main`
  background-color: ${theme.Colors.background};
  position: relative;
`
